(function() {
  $(document).ready(function () {
    // Trigger the change event for pre-selected variants on page load
    var setSelectedInputInterval = setInterval(function() {
      var selectedInput = $('.bundle_wrapper_selection .swatch_options .sizes_main .sizes_item input:checked');
      if (selectedInput.length > 0) {
        selectedInput.trigger('change');
        clearInterval(setSelectedInputInterval);
      }
    }, 1);
  
    // Handle change event for when a user selects a variant
    $(document).on('change', '.bundle_wrapper_selection .swatch_options .sizes_main .sizes_item input', function () {
      // Get the data-free-gifts-products attribute and split it into an array
      var giftProducts = $(this).data('free-gifts-products');
      var giftProductIds = giftProducts ? giftProducts.toString().split(',') : [];
  
      // Loop through each .free_gift-list-item and toggle the active class
      $('.free_gift-list-item').each(function () {
        var productId = $(this).data('product-id').toString();
        if (giftProductIds.includes(productId)) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    });
  });

  /*$(document).ready(function () {
    $('.add_to_cart').on('click', function (e) {
      e.preventDefault();
  
      const $button = $(this).prop('disabled', true);
      const $form = $button.closest('form');
  
      // Collect selected free gift variants
      let selectedItems = [];
      $('.bundle_free_gift_wrapper .free_gift_content .free_gift-items .free_gift-list-item.active').each(function () {
        const variantId = $(this).data('variant-id');
        if (variantId) {
          selectedItems.push({ id: variantId, quantity: 1 });
        }
      });
  
      // Step 1: Get current cart contents
      $.getJSON('/cart.js', function (cart) {
        const currentVariantIds = cart.items.map(item => item.variant_id);
  
        // Step 2: Filter out items already in cart
        const itemsToAdd = selectedItems.filter(item => !currentVariantIds.includes(item.id));
  
        if (itemsToAdd.length === 0) {
          // Nothing to add, just submit the form
          $form.off('submit').trigger('submit');
          $button.prop('disabled', false);
          return;
        }
  
        // Step 3: Batch add all missing items
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: itemsToAdd }),
          contentType: 'application/json',
          dataType: 'json'
        })
        .done(data => {
          console.log('Successfully added items:', data);
        })
        .fail(err => {
          console.error('Error adding free products:', err.responseText || err);
        })
        .always(() => {
          $form.off('submit').trigger('submit');
          $button.prop('disabled', false);
        });
      });
    });
  });*/

  $(document).ready(function () {
    $('.add_to_cart').on('click', function (e) {
      e.preventDefault();
  
      const $button = $(this).prop('disabled', true);
      const $form = $button.closest('form');
  
      // Step 1: Collect selected gift variants
      let selectedItems = [];
      $('.bundle_free_gift_wrapper .free_gift_content .free_gift-items .free_gift-list-item.active').each(function () {
        const variantId = $(this).data('variant-id');
        if (variantId) {
          selectedItems.push({ id: variantId, quantity: 1 });
        }
      });
  
      // Step 2: Clear the cart via AJAX
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json'
      }).done(function () {
        console.log('Cart cleared.');
  
        // Step 3: If there are free products to add, do it
        if (selectedItems.length > 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: selectedItems }),
            contentType: 'application/json',
            dataType: 'json'
          }).done(function (data) {
            console.log('Free items added:', data);
          }).fail(function (err) {
            console.error('Error adding free items:', err.responseText || err);
          }).always(function () {
            $form.off('submit').trigger('submit');
            $button.prop('disabled', false);
          });
        } else {
          // No items to add, just submit
          $form.off('submit').trigger('submit');
          $button.prop('disabled', false);
        }
      }).fail(function (err) {
        console.error('Failed to clear cart:', err.responseText || err);
        $form.trigger('submit'); // Submit anyway as fallback
        $button.prop('disabled', false);
      });
    });
  });

  
  $(document).ready(function () {
    updatePrice();
    updateAddToCart();
  });
  
  $(document).delegate(".bundle-product-bottles-options .bottles-options .bottle", "click", function() {
    var bottleCount = $(this).data('bottle-count');
    $(this).parents('.bottles-options').find('.bottle').removeClass('active');
    $(this).addClass('active');
    // $('#bottle_select_wrap p span').text(bottleCount);
    $('.bundle-product-list-items').attr('data-bottle-count', bottleCount);
    updatePrice();
    updateAddToCart(bottleCount);
  });
  
  $(document).delegate(".bundle-quantity-container .bundle-add-btn.is-active", "click", function() {
    $(this).removeClass('is-active');
    $(this).next('.bundle-quantity-box').addClass('is-active');
    $(this).parents('.bundle-product-list-item').addClass('item-active');
    var qtyDisplay = $(this).parents('.bundle-quantity-container').find('.bundle-qty-display');
    qtyDisplay.text(1);
    // $('#bundle_buy_button').removeAttr('disabled');
    updatePrice();
    updateAddToCart();
  });
  
  $(document).delegate(".bundle-quantity-container .qty-button-plus", "click", function() {
    var ele = $(this);
    qtyPlusMinus(ele);
  });
  
  $(document).delegate(".bundle-quantity-container .qty-button-minus", "click", function() {
    var ele = $(this);
    var qty = -1;
    qtyPlusMinus(ele, qty);
  });
  
  function qtyPlusMinus(ele, qty = 1) {
    var qtyDisplay = ele.parents('.bundle-quantity-box').find('.bundle-qty-display');
    var qtyDisplayText = qtyDisplay.text();
  
    if (parseInt(qty) == 1) {
      qtyDisplay.text(parseInt(qtyDisplayText)+parseInt(qty));
    } else if (parseInt(qtyDisplayText) > 1) {
      qtyDisplay.text(parseInt(qtyDisplayText)+parseInt(qty));
    } else {
      qtyDisplay.text(0);
      ele.parents('.bundle-quantity-box').removeClass('is-active');
      ele.parents('.bundle-product-list-item').removeClass('item-active');
      ele.parents('.bundle-quantity-container').find('.bundle-add-btn').addClass('is-active');
      // $('#bundle_buy_button').attr('disabled', 'disabled');
    }

    var bottleCount = $('.bottles-options .bottle.active').data('bottle-count');
    updatePrice();
    updateAddToCart(bottleCount);
  }

  $(document).delegate("input[data-smartrr-selling-plan-group-input]", "change", function () {
    updatePrice();
    updateAddToCart();
  });
  
  $(document).delegate("#bundle_buy_button", "click", function(e) {
    e.preventDefault();
    if (!$(this).prop('disabled')) {
      var bundleBuyButton = $(this);
      bundleBuyButton.attr('disabled', 'disabled');
      bundleBuyButton.addClass('disabled');
      bundleBuyButton.find('.loading__spinner').removeClass('hidden');
      // var has_subscription = $('.bundle-product-purchase-options .smartrr-otp.smartrr-group-inactive').length;
      var items = [];
      $('.bundle-product-list-items .bundle-product-list-item.item-active').each(function() {
        var productId = $(this).data('variant-id');
        var quantity = $(this).find('.bundle-qty-display').text();
        var sellingPlanId = $(this).data('selling-plan-id');
  
        // if (has_subscription == 1) {
          items.push({
            id: productId,
            quantity: parseInt(quantity),
            selling_plan: sellingPlanId
          });
        // } else {
        //   items.push({
        //     id: productId,
        //     quantity: parseInt(quantity)
        //   });
        // }
      });
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        dataType: 'json',
        contentType: 'application/json',
        success: function() {
          bundleBuyButton.removeAttr('disabled');
          bundleBuyButton.removeClass('disabled');
          bundleBuyButton.find('.loading__spinner').addClass('hidden');
          // alert('Items added to cart successfully!');
        },
        error: function() {
          bundleBuyButton.removeAttr('disabled');
          bundleBuyButton.removeClass('disabled');
          bundleBuyButton.find('.loading__spinner').addClass('hidden');
          // alert('There was an error adding items to the cart.');
        }
      });
    }
  });

  function formatPrice(price = 0) {
    var symbol = window.currencySymbol || '$';
    var code = window.currencyCode || 'USD';

    var formattedPrice = (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: code
    });

    return formattedPrice;
  }

  function updatePrice() {
    var activeBottle = $('.bottles-options .bottle.active');
    var subtotalWrapper = $('#bundle_subtotal_wrapper');
    var bottleCount = activeBottle.data('bottle-count');
    var bottleDiscount = activeBottle.data('discount');
    // var has_subscription = $('.bundle-product-purchase-options .smartrr-otp.smartrr-group-inactive').length;
    
    var itemActiveLength = $('.bundle-product-list-items .bundle-product-list-item.item-active').length;
    if (itemActiveLength == 0) {
      var product = $('.bundle-product-list-items .bundle-product-list-item:first');
      var price = product.data('price');
      var compareAtPrice = product.data('compare-at-price');
      var initialPrice = product.data('initial-price');
      var recurringPrice = product.data('recurring-price');
      var discountedPrice = price-(price*bottleDiscount/100);
      var discountedRecurringPrice = recurringPrice-(recurringPrice*bottleDiscount/100);

      // $('.product .product__info-wrapper [data-smartrr-form-id] [data-smartrr-selling-plan-group-id]').each(function () {
      //   $(this).find('[data-smartrr-compare-price]').text(formatPrice((compareAtPrice*bottleCount))).removeClass('hidden');
      //   // $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((recurringPrice*bottleCount))).removeClass('hidden');
      //   // $(this).find('[data-smartrr-regular-price]').text(formatPrice((price*bottleCount))).removeClass('hidden');
      //   $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((discountedRecurringPrice*bottleCount))+'/bottle').removeClass('hidden');
      //   $(this).find('[data-smartrr-regular-price]').text(formatPrice((discountedPrice*bottleCount))).removeClass('hidden');
      //   if ($(this).hasClass('smartrr-otp')) {
      //     // $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((price*bottleCount)));
      //     // $(this).find('[data-smartrr-regular-price]').text(formatPrice((compareAtPrice*bottleCount)));
      //     $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((discountedPrice*bottleCount))+'/bottle');
      //     // $(this).find('[data-smartrr-regular-price]').text(formatPrice((compareAtPrice*bottleCount)));
      //     $(this).find('[data-smartrr-regular-price]').text(formatPrice((price*bottleCount)));
      //     // if (compareAtPrice == 0) {
      //     //   $(this).find('[data-smartrr-regular-price]').addClass('hidden');
      //     // }
      //   }
      // });

      $(subtotalWrapper).addClass('hidden');
      $(subtotalWrapper).find('.bundle_subtotal p').text(formatPrice(0));
      $(subtotalWrapper).find('.bundle_subtotal_saving p').text(formatPrice(0));
    } else {
      var selectedBottleCount = bottleCount;
      var selectedBottleDiscount = bottleDiscount;
      var activeItems = $('.bundle-product-list-items .bundle-product-list-item.item-active');
      var totalQuantity = 0;
      $(activeItems).each(function() {
        var product = $(this);
        var quantity = product.find('.bundle-qty-display').text();
        totalQuantity = totalQuantity+parseInt(quantity);
      });
      $('.bottles-options .bottle').each(function() {
        var bottle_count = $(this).data('bottle-count');
        var bottle_discount = $(this).data('discount');
        if (totalQuantity >= bottle_count) {
          selectedBottleCount = bottle_count;
          selectedBottleDiscount = bottle_discount;
        }
      });
      
      // var product = $('.bundle-product-list-items .bundle-product-list-item:first');
      // var price = product.data('price');
      // var compareAtPrice = product.data('compare-at-price');
      // var initialPrice = product.data('initial-price');
      // var recurringPrice = product.data('recurring-price');
      // var discountedPrice = price-(price*selectedBottleDiscount/100);
      // var discountedRecurringPrice = recurringPrice-(recurringPrice*selectedBottleDiscount/100);
      // $('.product .product__info-wrapper [data-smartrr-form-id] [data-smartrr-selling-plan-group-id]').each(function () {
      //   $(this).find('[data-smartrr-compare-price]').text(formatPrice((compareAtPrice*selectedBottleCount))).removeClass('hidden');
      //   $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((discountedRecurringPrice*selectedBottleCount))+'/bottle').removeClass('hidden');
      //   $(this).find('[data-smartrr-regular-price]').text(formatPrice((discountedPrice*selectedBottleCount))).removeClass('hidden');
      //   if ($(this).hasClass('smartrr-otp')) {
      //     $(this).find('[data-smartrr-subscribe-price]').text(formatPrice((discountedPrice*selectedBottleCount))+'/bottle');
      //     $(this).find('[data-smartrr-regular-price]').text(formatPrice((price*selectedBottleCount)));
      //     // if (compareAtPrice == 0) {
      //     //   $(this).find('[data-smartrr-regular-price]').addClass('hidden');
      //     // }
      //   }
      // });

      var totalPrice = 0;
      var totalDiscountedPrice = 0;
      var totalRecurringPrice = 0;
      var totalDiscountedRecurringPrice = 0;
      var totalSavingPrice = 0;
      var totalSavingRecurringPrice = 0;
      $(activeItems).each(function() {
        var product = $(this);
        var price = product.data('price');
        var compareAtPrice = product.data('compare-at-price');
        var initialPrice = product.data('initial-price');
        var recurringPrice = product.data('recurring-price');
        var discountedPrice = price-(price*selectedBottleDiscount/100);
        var discountedRecurringPrice = recurringPrice-(recurringPrice*selectedBottleDiscount/100);
        var quantity = product.find('.bundle-qty-display').text();
        totalPrice = totalPrice+(price*quantity);
        totalRecurringPrice = totalRecurringPrice+(recurringPrice*quantity);
        totalDiscountedPrice = totalDiscountedPrice+(discountedPrice*quantity);
        totalDiscountedRecurringPrice = totalDiscountedRecurringPrice+(discountedRecurringPrice*quantity);
      });
      
      // if (has_subscription == 1) {
      //   // totalSavingRecurringPrice = totalRecurringPrice-totalDiscountedRecurringPrice;
      //   totalSavingRecurringPrice = totalPrice-totalDiscountedRecurringPrice;
      //   $(subtotalWrapper).find('.bundle_subtotal p').text(formatPrice(totalDiscountedRecurringPrice));
      //   $(subtotalWrapper).find('.bundle_subtotal_saving p').text(formatPrice(totalSavingRecurringPrice));
      // } else {
        totalSavingPrice = totalPrice-totalDiscountedPrice;
        $(subtotalWrapper).find('.bundle_subtotal p').text(formatPrice(totalDiscountedPrice));
        $(subtotalWrapper).find('.bundle_subtotal_saving p').text(formatPrice(totalSavingPrice));
      // }

      $(subtotalWrapper).removeClass('hidden');
    }
  }

  function updateAddToCart(bottleCount = $('.bottles-options .bottle.active').data('bottle-count')) {
    // var bottleCount = $('.bundle-product-list-items').data('bottle-count');
    var bundle_buy_button = $('#bundle_buy_button');
    var bottle_select_wrap = $('#bottle_select_wrap');
    var activeItems = $('.bundle-product-list-items .bundle-product-list-item.item-active');
    var activeItemsCount = $('.bundle-product-list-items .bundle-product-list-item.item-active').length;
    
    if (activeItemsCount > 0) {
      activeItemsCount = 0;
    }
    $(activeItems).each(function() {
      var activeItemQuantity = $(this).find('.bundle-qty-display').text();
      activeItemsCount = activeItemsCount+parseInt(activeItemQuantity);
    });
    
    if (bottleCount > activeItemsCount && activeItemsCount != 0) {
      bottleCount = bottleCount - activeItemsCount;
      $(bundle_buy_button).find('span').text('Select '+bottleCount+' More bottles');
      $(bundle_buy_button).attr('disabled', 'disabled');
      $(bottle_select_wrap).find('.select_more span').text(bottleCount);
      $(bottle_select_wrap).find('.select_more').removeClass('hidden');
      $(bottle_select_wrap).find('.all_set').addClass('hidden');
    } else if (activeItemsCount == 0) {
      $(bundle_buy_button).find('span').text('Select '+bottleCount+' More bottles');
      $(bundle_buy_button).attr('disabled', 'disabled');
      $(bottle_select_wrap).find('.select_more span').text(bottleCount);
      $(bottle_select_wrap).find('.select_more').removeClass('hidden');
      $(bottle_select_wrap).find('.all_set').addClass('hidden');
    } else {
      $(bundle_buy_button).find('span').text('Add to cart');
      $(bundle_buy_button).removeAttr('disabled');
      $(bottle_select_wrap).find('.select_more').addClass('hidden');
      $(bottle_select_wrap).find('.all_set').removeClass('hidden');
    }
  }
})();